import React, { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
import { Navbar } from "../../Components/Navbar/Navbar";
import { Footer } from "../../Components/Footer/footer";
import "./style.css";

interface Member {
  id: string;
  name: string;
  role: string;
  phone: string;
  email: string;
  image_url: string;
}

export function ConducerePage() {
  const [headerImage, setHeaderImage] = useState("");
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [members, setMembers] = useState<Member[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      const ref = doc(db, "site_content", "leadership_page");
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setHeaderImage(data.header_image || "");
        setTitle(data.title || "");
        setDescription(data.description || "");
        setMembers(data.members || []);
      }
    };
    fetchData();
  }, []);

  const generateVCard = (member: Member) => {
    const vcard = `
BEGIN:VCARD
VERSION:3.0
N:${member.name}
FN:${member.name}
TITLE:${member.role}
TEL;TYPE=WORK,VOICE:${member.phone}
EMAIL:${member.email}
END:VCARD
    `.trim();

    const blob = new Blob([vcard], { type: "text/vcard" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `${member.name.replace(/\s+/g, "_")}.vcf`;
    link.click();
  };

  return (
    <div className="page-container">
      <Navbar />

      {headerImage && (
        <div
          className="leadership-banner"
          style={{ backgroundImage: `url(${headerImage})` }}
        />
      )}

      <div className="page-content">
        <h1>{title}</h1>
        <p className="leadership-description">{description}</p>

        <div className="member-grid">
          {members.map((m) => (
            <div key={m.id} className="member-card">
              <img src={m.image_url} alt={m.name} className="member-photo" />
              <h3>{m.name}</h3>
              <p className="member-role">{m.role}</p>
              <p>{m.phone}</p>
              <p>{m.email}</p>
              <button onClick={() => generateVCard(m)}>Descarcă vCard</button>
            </div>
          ))}
        </div>
      </div>

      <Footer />
    </div>
  );
}
